import { Icon, useAccordionItemState, type IconProps } from "@project/ui";

export function AccordionIcon(props: IconProps) {
    const { isOpen } = useAccordionItemState();

    return <Icon name={isOpen ? "minus" : "plus"} size={"x-small"} {...props} />;
}

AccordionIcon.displayName = "AccordionIcon";
